import { Component } from '@angular/core';
import { LoginComponent } from '../login/login.component';

@Component({
    selector: 'core-login-faqs',
    templateUrl: './login-faqs.component.html',
    standalone: false,
})
export class LoginFaqsComponent extends LoginComponent {}
